var render = function render(){var _vm=this,_c=_vm._self._c;return (
    _vm.currentBillPeppolStatus &&
    _vm.currentBillPeppolStatus.companyIsPeppol &&
    _vm.currentBillPeppolStatus.billQualifiesForPeppol
  )?_c('v-text-field',{staticClass:"mx-2",style:({ maxWidth: '150px' }),attrs:{"label":'PEPPOL ' + _vm.$t('billings.status'),"disabled":true,"value":_vm.currentBillPeppolStatus.message},scopedSlots:_vm._u([{key:"prepend-inner",fn:function(){return [_c('v-icon',{attrs:{"color":_vm.currentBillPeppolStatus.color}},[_vm._v("mdi-send-outline")])]},proxy:true}],null,false,3873837583)}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }